module.exports = __webpack_public_path__ + "img/鲜花.befc777d.png";